import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './styles.scss';


NavBar.propTypes = {
  left: PropTypes.node,
  center: PropTypes.node,
  right: PropTypes.node,
  className: PropTypes.string
};

NavBar.defaultProps = {
  left: null,
  center: null,
  right: null,
  className: undefined
};

export default function NavBar(props) {
  const {
    left, center, right, className
  } = props;
  const cls = classnames(className, 'component-nav-bar');

  return (
    <nav className={cls}>
      <div className="component-nav-bar-left">{left}</div>
      <div className="component-nav-bar-center">{center}</div>
      <div className="component-nav-bar-right">{right}</div>
    </nav>
  );
}
